import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { BaseHttpService } from './base-http.service';
import { environment } from '../../environments/environment';

export interface SystemInfo {
  frontend_deploy_time: string;
  backend_deploy_time: string;
  database_name: string;
  environment: string;
}

@Injectable({
  providedIn: 'root'
})
export class SystemInfoService extends BaseHttpService {
  /**
   * Rendszerinformációk lekérése
   * Frontend deploy time-ot az environment-ből veszi
   */
  getSystemInfo(): Observable<SystemInfo> {
    return this.get<SystemInfo>('/system-info').pipe(
      map(backendInfo => ({
        ...backendInfo,
        frontend_deploy_time: environment.deployTime || backendInfo.frontend_deploy_time
      }))
    );
  }
}
